import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter as Router} from 'react-router-dom';
import {Provider} from 'react-redux';
import Store from './lib/store';
import Views from './views';
import {ToastContainer, Flip} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'tippy.js/dist/tippy.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
    <Router>
        <ToastContainer
          position="top-right"
          autoClose={3e3}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="dark"
          transition={Flip} />
        <Provider store={Store}>
          <Views />
        </Provider>
    </Router>
);

reportWebVitals();